module.exports = __webpack_public_path__ + "assets/images/img/google-play-store.fbc7155f6a7ff3a2b471c1d067ca4b76.svg";